import React from 'react';
import { Heart, Award, Users, Target } from 'lucide-react';

const AboutPage = () => {
  return (
    <div>
      <section className="bg-gradient-to-r from-teal-600 to-emerald-600 text-white py-20">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="text-5xl font-bold mb-6">About ADHD Life Online</h1>
            <p className="text-2xl mb-8 opacity-90">
              Built by people with ADHD, for people with ADHD
            </p>
          </div>
        </div>
      </section>

      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-3xl font-bold mb-8">Our Mission</h2>
            <p className="text-lg text-gray-700 mb-6">
              ADHD Life Online was founded on a simple belief: everyone with ADHD deserves access to quality resources, supportive community, and practical tools that actually work.
            </p>
            <p className="text-lg text-gray-700 mb-6">
              We understand the challenges because we live them every day. Our team is made up of individuals with ADHD, ADHD coaches, mental health professionals, and researchers dedicated to making life with ADHD more manageable.
            </p>
            <p className="text-lg text-gray-700">
              Our mission is to empower individuals with ADHD to thrive, not just survive, by providing evidence-based information, practical strategies, and a supportive community where everyone feels understood.
            </p>
          </div>
        </div>
      </section>

      <section className="py-16 bg-gradient-to-r from-teal-50 to-emerald-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-12 text-center">Our Values</h2>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 max-w-6xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Heart className="w-8 h-8 text-teal-600" />
              </div>
              <h3 className="font-bold text-xl mb-2">Empathy</h3>
              <p className="text-gray-600">We understand because we've been there</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Award className="w-8 h-8 text-teal-600" />
              </div>
              <h3 className="font-bold text-xl mb-2">Evidence-Based</h3>
              <p className="text-gray-600">All content reviewed by experts</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Users className="w-8 h-8 text-teal-600" />
              </div>
              <h3 className="font-bold text-xl mb-2">Community</h3>
              <p className="text-gray-600">Safe, supportive space for all</p>
            </div>
            <div className="text-center">
              <div className="w-16 h-16 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <Target className="w-8 h-8 text-teal-600" />
              </div>
              <h3 className="font-bold text-xl mb-2">Practical</h3>
              <p className="text-gray-600">Real strategies that work</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;